<template>
    <div class="risk-score-large col-xs-12">
        <div class="company-name-header col-xs-12">
            <div class="company-name-box col-xs-2" :style="{'background-color':'#'+files.overall_risk_bg}"
                 @mouseover="showTooltip(files.overall_risk_level_tooltip, $event)"
                 @mouseout="hideTooltip()">
                <p class="company-name-letter" style="padding-top:20px;">{{files.overall_risk_letter}}</p>
            </div>
            <div class="company-content col-xs-5">
                <div class="company-name">{{files.customer_name}}</div> <br>
                <div class="company-line" style="border-bottom: 1px solid #FAFAFA; width: 60%"></div> <br>
                <div class="company-percentage">Overall Threat: {{fixedRiskPercent}}%</div>
            </div>
            <div class="col-xs-4"></div>
            <div class="col-xs-1 logo-and-actions">
                <button id="send-threat-email-partner-button-large"
                        @click="send_threat_email_child(files.enterprise_id)" :disabled="is_send_threat_email_disabled">
                    <!--Send Threat Email-->
                    <img @mouseover="showTooltip('Send Threat Email', $event)"
                         @mouseout="hideTooltip()" src="../../../assets/mail.png" alt="Send Threat Email"
                         style="width: 26px; height: 18px">
                </button>
                <img id="send-threat-email-partner-indicator-large" src="../../../assets/mail-loading.gif"
                     style="display: none">
            </div>
        </div>
        <div class="risks-area col-xs-12" v-for="file in sortedFiles">
            <div class="risks-content col-xs-10">
                <div class="risks-content-name" style="border-bottom: 1px solid #FAFAFA;">{{file.risk_group_header}}</div>
                <div class="risks-content-percentage" :style="{'color':'#'+file.background}">{{file.percentage.toFixed()}}% - {{file.total_issue_count}} Issues
                    <p style="text-align: right; color: white; font-size:17px; margin-top:-25px;">{{file.risk_level}}</p></div>
                <div class="risks-sub">
                    <div class="risks-info" v-for="risks in file.risk_elements">
                        <div class="risks-rate-box" :style="{'background-color':'#'+risks.risk_level_bg}">
                            <p style="text-align: center; padding-top:4px; letter-spacing: 1px;">{{risks.risk_level}}</p>
                        </div>
                        <div class="risks-description-content col-xs-12">
                            <div class="risks-description col-xs-9">
                                <div class="risk-element-header">
                                    <a v-if="risks.issue_count" @click="clickRisk" :href = risks.path style="text-decoration: none; color: white !important;">{{risks.risk_element_header}}</a>
                                    <a v-if="!risks.issue_count" style="text-decoration: none; color: white !important;">{{risks.risk_element_header}}</a>
                                    <br>
                                </div>
                                <div class="risk-element-description">
                                    <div class="-risk-element-description-subline" style="margin-left:-45px; font-size: 15px; line-height: 15px;">|
                                        <div class="risk-element-description-line" style="border-bottom: 1px solid white; width: 10%; margin-left:2px;"></div>
                                    </div>
                                    <div class="risk-element-description-content">
                                        <a v-if="risks.issue_count" @click="clickRisk" :href = risks.path style="text-decoration: none; color: white !important;">{{risks.risk_element_description}}</a>
                                        <a v-if="!risks.issue_count" style="text-decoration: none; color: white !important;">{{risks.risk_element_description}}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="risks-issues col-xs-3">
                                <p v-if="risks.issue_count" @click="clickRisk" style="text-align: right"><a :href = risks.path style="text-decoration: none; color: white !important;">{{risks.issue_count}} unresolved issues</a></p>
                                <p v-if="!risks.issue_count" style="text-align: right">{{risks.issue_count}} unresolved issues</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="risks-box col-xs-2" :style="{'background-color':'#'+file.background}"
                 @mouseover="showTooltip(file.risk_letter_tooltip, $event)"
                 @mouseout="hideTooltip()">
                <p class="risks-box-letter" style="padding-top:10px;">{{file.risk_letter}}</p>
            </div>
        </div>
        <global-tooltip ref="tooltip"></global-tooltip>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import GlobalTooltip from '@/components/tooltip/GlobalTooltip.vue'

    export default {
        name: "risk-score-large",
        components: {
            GlobalTooltip: GlobalTooltip
        },
        props: {
            sortedFiles: {
                type: Array,
                required: true
            },
            files: {
                type: Object,
                required: true
            },
            is_send_threat_email_disabled: {
                type: Boolean,
                required: false
            },
            send_threat_email: {
                type: Function,
                required: false
            }
        },
        methods: {
            send_threat_email_child(enterprise_id) {
                this.$emit('send_threat_email', enterprise_id);
            },
            clickRisk(){
                // this.$emit('this.notificationExtendable', this.getNotificationExtendable);
                // this.notificationExtendable(this.getNotificationExtendable);
                this.setNotificationExtendable(true);

            },
            showTooltip (text, e) {
                this.$refs.tooltip.showTooltip(e.clientY + 10, e.clientX + 10, text);
            },
            hideTooltip() {
                this.$refs.tooltip.hideTooltip();
            },
            ...mapActions([
                "setNotificationExtendable"
            ])
        },
        computed: {
            fixedRiskPercent: function() {
                if(this.files.overall_risk_percent != null)
                    return this.files.overall_risk_percent.toFixed();
            }
        },
        mounted(){
            this.clickRisk();
        }
    }
</script>

<style scoped>
    .logo-and-actions {
        /*margin-top: 32px;*/
        font-family: Digital-Serial-Bold;
    }

    .logo-and-actions button {
        background: black;
        border: 0;
        color: white;
        font-size: 16px;
        /*margin-left: 100px;*/
        margin-top: 19px;
        margin-left: 8px;
    }

    .risk-score-large{
        overflow-y: scroll;
        overflow-x: hidden;
        box-sizing: content-box;
        height: 90vh;
    }

    .company-name-header{
        margin-top: 15px;
    }

    .company-name-box{
        height: 100px;
        width: 100px;
        text-align: center;
        font-size: 40px;
        color: white;
        font-family: Titillium Web Bold;
    }

    .company-percentage{
        font-size: 40px;
        color: white;
        font-family: Digital-Serial-Bold;
        margin-top: -20px;
    }

    .company-name{
        font-size: 30px;
        color: white;
        font-family: Digital-Serial-Bold;
        margin-bottom:10px;
    }

    .company-line{
        margin-top: -25px;
    }

    .risks-content{
        margin-top:30px;
    }

    .risks-area{
        margin-left: -17px;
        margin-top: 15px;
    }

    .risks-box{
        height: 80px;
        width: 80px;
        text-align: center;
        font-size: 40px;
        color: white;
        font-family: Titillium Web Bold;
        margin-left: 135px;
        margin-top: 20px;
    }

    .risks-content{
        margin-top: 30px;
    }

    .risks-content-name{
        font-size: 22px;
        color: white;
        font-family: Digital-Serial-Bold;
        width: 110%;
    }

    .risks-content-percentage{
        font-size: 22px;
        width: 110%;
        font-family: Digital-Serial-Bold;
    }

    .risks-sub{
        margin-top: 30px;
    }

    .risks-info{
        margin-bottom: 100px;
    }

    .risks-rate-box{
        height: 30px;
        width: 150px;
        font-size:17px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        font-family: Titillium Web Bold;
        color: white;
    }

    .risks-description{
        margin-top:5px;
    }

    .risks-description-content{
        color: white;
        font-size: 15px;
        margin-left:150px;
        margin-top: -32px;
    }

    .risk-element-header{
        font-family: Titillium Web Bold;
    }

    .risk-element-description{
        margin-left: 50px;
        margin-top: 10px;
        font-family: Titillium Web Regular;
    }

    .risk-element-description-content{
        word-wrap: break-word;
        margin-left: 50px;
        margin-top: -15px;
    }

    .risks-issues{
        font-family: Titillium Web Bold;
    }

    @media only screen and (min-width: 2000px) {
        .risk-element-description-content{
            margin-left: 60px;
        }
    }

    @media only screen and (max-width: 1700px) {
        .risks-content-name{
            width: 110%;
        }

        .risks-content-percentage{
            width: 110%;
        }
        .risks-box{
            margin-left: 100px;
        }
    }

    @media only screen and (min-width: 2300px) {
        .risk-element-description-content{
            margin-left: 100px;
        }

        .risks-content-name{
            width: 107%;
        }

        .risks-content-percentage{
            width: 107%;
        }

        .risk-score-large{
            height: 1200px;
        }

        .risk-element-description-line{
            width: 15%;
            border-bottom: 2px solid white !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard-page/risk-score/RiskScoreLarge.vue